import _isNumber from "lodash/isNumber";
import loanProgramToMonths from './lib/loan-program-to-months';
import getMIPInPercent from './lib/mip-percent';
/**
 * Gets the yearly mortgage insurance premium (MIP) for FHA loans
 * @module calculate-mip
 * @param  {Object} data
 * @param  {Number} data.loanAmount     The amount of the loanAmount
 * @param  {Number} data.loanTermMonths Loan term in months
 * @param  {Number} data.purchasePrice  Optional. Original purchase price of home
 * @return {Number} The yearly premium
 */

export default (function (_ref) {
  var loanAmount = _ref.loanAmount,
      loanProgram = _ref.loanProgram,
      purchasePrice = _ref.purchasePrice;
  var loanTermMonths = loanProgramToMonths(loanProgram);

  if (!_isNumber(loanAmount) || !_isNumber(loanTermMonths)) {
    return 0;
  }

  return getMIPInPercent(loanAmount, loanTermMonths, purchasePrice) * loanAmount;
});